'use client';

import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '@/lib/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;
const TooltipContent = /*#__PURE__*/React.forwardRef(({
  className,
  enableAnimation = false,
  sideOffset = 4,
  ...props
}, ref) => {
  const animationClasses = enableAnimation ? 'animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2' : 'opacity-100 scale-100';
  return /*#__PURE__*/_jsx(TooltipPrimitive.Portal, {
    children: /*#__PURE__*/_jsx(TooltipPrimitive.Content, {
      ref: ref,
      sideOffset: sideOffset,
      className: cn('z-50 overflow-hidden rounded-md px-3 py-1.5 origin-[--radix-tooltip-content-transform-origin]', animationClasses, className),
      ...props
    })
  });
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };